/**
 * Apply backend auth session to localStorage + parent onLogin callback.
 */
export function applyAuthSession(session, onLogin) {
  const {
    access_token: accessToken,
    user_type: userType,
    requires_pin_setup: requiresPinSetup = false,
    requires_phone_setup: requiresPhoneSetup = false,
    is_new_user: isNewUser = false,
  } = session;

  onLogin(accessToken, userType, requiresPinSetup);

  if (requiresPhoneSetup) {
    localStorage.setItem("proovam_requires_phone", "true");
  } else {
    localStorage.removeItem("proovam_requires_phone");
  }

  if (userType === "client" && isNewUser) {
    localStorage.removeItem("proovam_client_onboarding_done");
  }

  if (userType === "brm" && isNewUser) {
    localStorage.removeItem("proovam_onboarding_done");
  }

  if (userType === "brm" && !requiresPinSetup) {
    localStorage.setItem("proovam_requires_pin", "false");
  }
}
